import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPinnedPostsKey } from '../../utils/keys';
export const usePinnedPosts = (options) => {
    const { variables, fields = 'default', useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const pinnedPostsKey = getPinnedPostsKey({ variables, fields });
    return useQuery(pinnedPostsKey, () => client === null || client === void 0 ? void 0 : client.spaces.pinnedPosts(variables, fields), useQueryOptions);
};
//# sourceMappingURL=usePinnedPosts.js.map